// extracted by mini-css-extract-plugin
export default {"container":"ncmViewContainerList_container__GL-8Y"};